import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { fetchContent } from "@/lib/useContent";

// Kick off the CMS fetch for the home page as early as possible —
// before React mounts. This gives the network request a head start
// of ~200–400ms over `useContent` (which only fires from a useEffect
// AFTER the first render). On cold loads this is often enough for the
// data to arrive before any CMS-bound component renders, eliminating
// the "default media flash" race on home.
if (typeof window !== "undefined") {
  try {
    fetchContent("home");
  } catch {
    /* network failure is non-fatal — fetchContent retries via useContent */
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
